import styles from './defaultPage.less'; export {styles};

interface DefaultPageProps {
    onClickAgree: () => void;
    onClickDisagree: () => void;
    onClickCustomize: () => void;
    onClickLegalDetails: () => void;
}

export default class DefaultPage extends React.Component<DefaultPageProps, null> {

    private readonly _bodyRef;

    constructor(props) {
        super(props);

        this._bodyRef = React.createRef();

        this.onClickSocialConnect = this.onClickSocialConnect.bind(this);
    }

    componentDidMount() {
        $j('[data-js=legal-details]', this._bodyRef.current).on('click', this.props.onClickLegalDetails);
    }

    componentWillUnmount() {
        $j('[data-js=legal-details]', this._bodyRef.current).off('click', this.props.onClickLegalDetails);
    }

    onClickSocialConnect(connector) {
        this.props.onClickAgree();

        if (typeof connector == 'undefined') {
            return;
        }

        let socialConnectClick = true;

        connector.onServerConnectBefore(function(event) {
            if (!socialConnectClick) {
                return;
            }

            socialConnectClick = false;

            event.getData().data.cookiesModal = 1;
        });

        connector.connect().done(function() {
            location.reload();
        });
    }

    render() {
        return (
            <>
                <div className={styles.body} ref={this._bodyRef}
                     dangerouslySetInnerHTML={{__html: _('[COOKIES_MODAL] DEFAULT DESCRIPTION', AitiCore.getWebsite().getName(), _('[COOKIES_MODAL] I agree'))}}/>
                <div className={styles.buttons}>
                    <div className={classNames(styles.button, styles.conversion)} onClick={() => this.props.onClickAgree()}>{_('[COOKIES_MODAL] I agree')}</div>
                    <div className={classNames(styles.button)} onClick={() => this.props.onClickCustomize()}>{_('[COOKIES_MODAL] Customize')}</div>
                </div>
            </>
        );
    }
}
